


























































import { Component, Ref, Vue } from "vue-property-decorator";
import request from "@/api/index";
import { dragVerifyGetCodeData } from "@/api/types";
import {
  aesEncrypt,
  sendCaptchaVerification
} from "@/common/DragVerify/DragVerify";
@Component({})
export default class DragVerify extends Vue {
  //图片资源是否加载完毕
  isComplete = false;

  appId: number = 1;

  //控制拖拽轨道初始提示信息显示隐藏
  initTipsShow = true;

  //控制拖拽轨道验证码校验成功提示信息显示隐藏
  successTipsShow = false;

  //是否可以重新获取验证码
  canRefresh = true;

  //轨道滑块滑动距离
  distanceX = 0;

  //pointJson字段
  pointJson: string = "";

  //拼图背景宽度
  bgWidth = 0;

  //拼图滑块宽度
  blockPuzzleWidth = 0;

  //touchStart pageX
  mouseDownX = 0;

  //判断元素是否被拖拽
  flag = false;

  //拼图滑块
  @Ref("blockPuzzleRef")
  blockPuzzleRef!: HTMLImageElement;

  //拼图背景
  @Ref("bgRef")
  bgRef!: HTMLImageElement;

  //拖拽滑块
  @Ref("dragBlockRef")
  dragBlockRef!: HTMLDivElement;

  //滑块轨道上提示信息
  @Ref("dragBlockTipsRef")
  dragBlockTipsRef!: HTMLDivElement;

  //滑块轨道容器
  @Ref("dragBlockContainerRef")
  dragBlockContainerRef!: HTMLDivElement;

  //人机校验数据
  dragVerifyData: dragVerifyGetCodeData = {} as dragVerifyGetCodeData;

  //校验成功返回的票据
  captchaVerification: string = "";

  //状态图标
  statusIcoUrl = {
    initUrl: require("@/assets/images/drag-verify/drag-clock-1@2x.png"),
    successUrl: require("@/assets/images/drag-verify/drag-clock-2@2x.png"),
    failUrl: require("@/assets/images/drag-verify/drag-clock-3@2x.png")
  };

  //获取验证码
  async getCode() {
    const params: { captchaType: string; ts: number; appId: number } = {
      captchaType: "blockPuzzle",
      ts: new Date().getTime(),
      appId: this.appId
    };
    const res = await request.dragVerifyGetCode(params);
    if (res.code !== 0) throw new Error(res.message);
    this.dragVerifyData = res.data;
  }

  // 校验验证码正确性
  async checkCode(pointJson: string) {
    const params: {
      captchaType: string;
      pointJson: string;
      token: string;
      ts: number;
      appId: number;
    } = {
      captchaType: "blockPuzzle",
      pointJson,
      token: this.dragVerifyData.token,
      ts: new Date().getTime(),
      appId: this.appId
    };
    try {
      const res = await request.dragVerifyCheckCode(params);
      if (res.code !== 0) throw new Error(res.message);
      this.captchaVerification = res.data.captchaVerification;
      return res.data.captchaVerification;
    } catch (e) {
      console.log(e);
    }
  }

  //重新获取验证码
  async refresh() {
    if (!this.canRefresh) return;
    this.isComplete = false;
    await this.getCode();
    this.dragBlockRef.style.left = 0 + "px";
    this.blockPuzzleRef.style.left = 0 + "px";
    this.dragBlockContainerRef.style.borderColor = "#13CBB9";
    this.dragBlockRef.style.backgroundImage = `url(${this.statusIcoUrl.initUrl})`;
    this.initTipsShow = true;
    this.handleJigsawChange();
  }

  created() {
    this.getAppId();
    this.refresh();
  }

  getAppId() {
    const ua = window.navigator.userAgent.toLowerCase();
    // const ua = "mozilla/5.0 (iphone; cpu iphone os 13_2_3 like mac os x) applewebkit/605.1.15 (khtml, like gecko) version/13.0.3 mobile/15e148 safari/604.1 CQ_XHL(v1.1;Android/IOS;12)".toLowerCase();
    const index = ua.indexOf("cq_xhl");
    if (index !== -1) {
      const str = ua.slice(index + 7, -1);
      const appId = Number(str.split(";")[2]);
      appId && (this.appId = appId);
      console.log("appid", appId);
    }
  }

  //处理拼图url改变
  handleJigsawChange() {
    let bgLoaded = false;
    let blockPuzzleLoaded = false;
    this.bgRef.addEventListener("load", () => {
      this.bgWidth = this.bgRef.offsetWidth;
      bgLoaded = true;
    });
    this.blockPuzzleRef.addEventListener("load", () => {
      this.blockPuzzleWidth = this.blockPuzzleRef.offsetWidth;
      blockPuzzleLoaded = true;
    });
    const timer = setInterval(() => {
      if (bgLoaded && blockPuzzleLoaded) {
        this.isComplete = true;
        clearInterval(timer);

        if (this.dragBlockContainerRef) {
          this.dragBlockContainerRef.style.width =
            this.bgWidth -
            this.blockPuzzleWidth +
            parseFloat(window.getComputedStyle(this.dragBlockRef).width) +
            "px";
        }
        this.bindEvent();
      }
    }, 100);
  }

  mounted() {}

  //拖动开始
  touchStart() {
    this.mouseDownX =
      (window.event as any).clientX || (window.event as any).touches[0].clientX;

    this.initTipsShow = false;

    this.canRefresh = false;
    //表示鼠标已按下
    this.flag = true;

    window.addEventListener("touchmove", this.touchMove);
    window.addEventListener("touchend", this.touchEnd);
    window.addEventListener("mousemove", this.touchMove);
    window.addEventListener("mouseup", this.touchEnd);
  }

  //拖动
  touchMove() {
    // 确保鼠标已按下
    if (this.flag) {
      const mouseMoveX =
        (window.event as any).clientX ||
        (window.event as any).touches[0].clientX;
      this.distanceX = mouseMoveX - this.mouseDownX;
      const maxDistanceX = this.bgWidth - this.blockPuzzleWidth;

      if (this.distanceX > maxDistanceX) {
        this.distanceX = maxDistanceX;
      } else if (this.distanceX < 0) {
        this.distanceX = 0;
      }
      this.dragBlockRef.style.left = this.distanceX + "px";
      this.blockPuzzleRef.style.left = this.distanceX + "px";
    }
  }

  //拖动结束
  touchEnd() {
    this.flag = false;
    this.unbindEvent();
    this.pointJson = aesEncrypt(
      JSON.stringify({ x: this.distanceX, y: 5.0 }),
      this.dragVerifyData.secretKey
    );
    this.checkCode(this.pointJson).then(res => {
      if (res) {
        this.successTipsShow = true;
        sendCaptchaVerification(this.captchaVerification);
      } else {
        this.dragBlockContainerRef.style.borderColor = "#FF5353";
        this.dragBlockRef.style.backgroundImage = `url(${this.statusIcoUrl.failUrl})`;
        setTimeout(() => {
          this.canRefresh = true;
          this.refresh();
        }, 2000);
      }
    });
  }

  //绑定事件
  bindEvent() {
    this.dragBlockRef.addEventListener("touchstart", this.touchStart);
    this.blockPuzzleRef.addEventListener("touchstart", this.touchStart);
    this.dragBlockRef.addEventListener("mousedown", this.touchStart);
    this.blockPuzzleRef.addEventListener("mousedown", this.touchStart);
  }
  //解绑事件
  unbindEvent() {
    this.dragBlockRef.removeEventListener("touchstart", this.touchStart);
    this.blockPuzzleRef.removeEventListener("touchstart", this.touchStart);
    window.removeEventListener("touchmove", this.touchMove);
    window.removeEventListener("touchend", this.touchEnd);
    this.dragBlockRef.removeEventListener("mousedown", this.touchStart);
    this.blockPuzzleRef.removeEventListener("mousedown", this.touchStart);
    window.removeEventListener("mousemove", this.touchMove);
    window.removeEventListener("mouseup", this.touchEnd);
  }
}
